import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m7.439 2.125 3.366 3.366a.717.717 0 0 1 0 1.018L7.439 9.875a.504.504 0 0 0 0 .735l.679.68a.504.504 0 0 0 .735 0l4.921-4.922a.504.504 0 0 0 0-.736L8.853.711a.504.504 0 0 0-.735 0l-.68.679a.504.504 0 0 0 0 .735M1.047 4.953l-.68.68a.504.504 0 0 0 0 .735l.68.679a.504.504 0 0 0 .735 0l.537-.538a.717.717 0 0 1 1.019 0l.537.538a.504.504 0 0 0 .735 0l.538-.538a.717.717 0 0 1 1.018 0l.537.538a.504.504 0 0 0 .736 0l.679-.68a.504.504 0 0 0 0-.735l-.68-.679a.504.504 0 0 0-.735 0l-.537.538a.717.717 0 0 1-1.018 0l-.538-.538a.504.504 0 0 0-.735 0l-.537.538a.717.717 0 0 1-1.019 0l-.537-.538a.504.504 0 0 0-.735 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }